//#region imports
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
//#endregion

@Component({
  selector: 'app-server-fail-error',
  templateUrl: './server-fail-error.component.html',
  styleUrls: ['./server-fail-error.component.css']
})
export class ServerFailErrorComponent implements OnInit {
  //#region variables
  title: string;
  disableClose: false;
  errorMessage: string; // = "Server is unavailable. Please try after sometime";
  //#endregion

  //#region methods
  constructor(private dialogRef: MatDialogRef<ServerFailErrorComponent>,  @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.errorMessage = this.data.errorMessage;
    this.title = this.data.title;
    this.disableClose = this.data.disableClose;
  }

  onClose() {
    this.dialogRef.close(true);
  }
  //#endregion
}
